import React from 'react';

/** Bar widths per row — slight variation so rows don't look copy-pasted. */
const ROW_PATTERNS = [
    ['w-4 h-4 rounded', 'w-36', 'w-24', 'w-28', 'w-20', 'w-24', 'w-20', 'w-14', 'w-6'],
    ['w-4 h-4 rounded', 'w-44', 'w-20', 'w-32', 'w-16', 'w-28', 'w-24', 'w-16', 'w-6'],
    ['w-4 h-4 rounded', 'w-32', 'w-28', 'w-24', 'w-24', 'w-20', 'w-28', 'w-14', 'w-6'],
    ['w-4 h-4 rounded', 'w-40', 'w-16', 'w-36', 'w-20', 'w-24', 'w-16', 'w-16', 'w-6'],
    ['w-4 h-4 rounded', 'w-28', 'w-24', 'w-28', 'w-16', 'w-32', 'w-20', 'w-14', 'w-6'],
    ['w-4 h-4 rounded', 'w-36', 'w-20', 'w-32', 'w-24', 'w-20', 'w-24', 'w-16', 'w-6'],
];

const barClass = (widthClass) =>
    widthClass.includes('h-')
        ? `shrink-0 animate-pulse bg-gray-100 ${widthClass}`
        : `h-3 shrink-0 animate-pulse rounded-md bg-gray-100 ${widthClass}`;

/**
 * Skeleton rows for table loading states (use inside Table.Body via Table.js).
 */
export function TableSkeletonRows({ Row, Cell, rowCount = 5 }) {
    return Array.from({ length: rowCount }, (_, rowIndex) => {
        const pattern = ROW_PATTERNS[rowIndex % ROW_PATTERNS.length];
        return (
            <Row key={`table-skeleton-${rowIndex}`} className="bg-white">
                <Cell colSpan={100} className="py-3.5">
                    <div
                        className="flex min-w-[36rem] items-center gap-4 md:gap-6"
                        aria-hidden="true"
                    >
                        {pattern.map((widthClass, cellIndex) => (
                            <div
                                key={cellIndex}
                                className={barClass(widthClass)}
                                style={{ animationDelay: `${rowIndex * 60}ms` }}
                            />
                        ))}
                    </div>
                </Cell>
            </Row>
        );
    });
}

export default TableSkeletonRows;
